export const columns = [
  {
    title: 'Năm',
    key: 'year',
    sorter: true,
    dataIndex: 'year',
  },
];
